module.exports = __webpack_public_path__ + "752798310a5462224a1fb1f4215a5515.svg";